module.exports = __webpack_public_path__ + "img/check.5f1ea13d.png";